import React, { Suspense, lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import Auth from '../../../../Layout/Auth';
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined;

// Loading component
function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading</span>
      </div>
    </>
  );
}

// Import pages
const TransactionList = lazy(() => import('../Pages/TransactionList'));
const AddTransaction = lazy(() => import('../Pages/AddTransaction'));
const EditTransaction = lazy(() => import('../Pages/EditTransaction'));
const TransactionView = lazy(() => import('../Pages/TransactionView'));

/**
 * TransactionRoute component
 * Defines all routes related to the Transaction module
 */
const TransactionRoute = ({ match }) => {
  const { path } = match;
  return (
    <Switch>
      <Route
        exact
        path={`${path}`}
        render={(routeProps) => (
          <Auth allowedRoles={['app_admin', 'admin', 'staff', 'agent']} {...routeProps}>
            <Suspense fallback={<Loading />}>
              <TransactionList />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path={`${path}/add`}
        render={(routeProps) => (
          <Auth allowedRoles={['app_admin', 'admin', 'staff', 'agent']} {...routeProps}>
            <Suspense fallback={<Loading />}>
              <AddTransaction />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path={`${path}/edit/:slack`}
        render={(routeProps) => (
          <Auth allowedRoles={['app_admin', 'admin', 'staff', 'agent']} {...routeProps}>
            <Suspense fallback={<Loading />}>
              <EditTransaction isEdit={true} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path={`${path}/view/:slack`}
        render={(routeProps) => (
          <Auth allowedRoles={['app_admin', 'admin', 'staff', 'agent']} {...routeProps}>
            <Suspense fallback={<Loading />}>
              <TransactionView />
            </Suspense>
          </Auth>
        )}
      />
    </Switch>
  )
};

export default TransactionRoute;
